import fpApiUtil from "./fp-api-util";

const ANALYSIS = "factoryplan/analysis";

// 툴 가용성(공장>스테이지>툴자원별 최대투입율/최대투입량/최소잔여량/공급/폐기 개수 크로스탭) —
// AnalysisController#getToolAvailability(백엔드는 factoryplan/analysis/tool-availability). 다른
// 크로스탭 화면과 같은 { crosstabHeader, chartHeader, data[].pivotData } 형태, measure
// (analysisIndicator)가 leaf 필드. 백엔드는 old에 없던 FP_TOTAL_AVAIL_CNT까지 6종을 내려주지만
// changes를 비워 보내면(§A-6e와 동일 이유로 컬럼필터 트리거 UI가 없어 항상 빈 객체) 필터링되지
// 않으므로, old parity를 위해 화면(ToolAvailability.js)이 FP_TOTAL_AVAIL_CNT 행을 클라에서 제외한다.
// old도 그리드 조회(loadData)/차트 드릴다운(loadChartData) 둘 다 같은 엔드포인트를 호출한다.
const getToolAvailabilities = (params) => fpApiUtil.postParams(`${ANALYSIS}/tool-availability`, params);

// 같은 엔드포인트의 차트용 호출 — 그리드에서 클릭한 행(plantCd/stageCd/toolResourceCd)으로
// 드릴다운, useGrouping:true로 그 레벨까지 백엔드가 집계해서 내려준다(ToolAvailabilityCrosstabDto
// .merge, GroupingLevel 참고, ResourceUtilization과 동일 계열). 컬럼 필터(changes)는 1차 미이관이라
// 항상 빈 객체로 보낸다(fp-report-screen-guide.md §A-6e와 동일 결정).
const getToolAvailabilityChart = (params, changes) =>
  fpApiUtil.postFields(`${ANALYSIS}/tool-availability`, { params, changes });

const fpToolAvailabilityService = { getToolAvailabilities, getToolAvailabilityChart };
export default fpToolAvailabilityService;
